import * as React from "react";
import { Reducer } from "./Reducer";
import {
  AppProps,
  inAppState,
  WINDOW_VIEWS,
  inAppInitialState,
  AppInitState,
  AppState
} from "./StateAndProps";
import { ACTIONS, TYPES } from "./Actions";
import * as _ from "lodash";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import {
  HashRouter as Router,
  Route,
  Link,
  Switch,
  Redirect
} from "react-router-dom";

import HomePage from "../../pages/Homepage/Homepage";
import SelectionPage from "../../pages/SelectionPage/SelectionPage";

import { DataService } from "../../services/DataService";
import { IS_EMBED, IS_MOBILE } from "../../config";
import MainPage from "../../pages/MainPage/MainPage";

export const STATE_KEY = "app";

class App extends React.Component<AppProps, inAppState> {
  DS: DataService;
  constructor(props: AppProps) {
    super(props);
    this.state = inAppInitialState;
    this.DS = new DataService();
  }

  componentDidMount() {
    if (this.DS.isDataLoaded) {
      const dd = this.props.loadData(this.DS.getData());
    } else {
      this.DS.load()
        .then(e => {
          return this.props.loadData(e);
        })
        .then(res => {});
    }

    window.addEventListener("resize", this.resize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize);
  }

  resize = () => {
    this.forceUpdate();
  };

  render() {
    let state = this.state,
      props = this.props;
    let embedCls = IS_EMBED ? "embed" : "";
    let mobileCls = IS_MOBILE ? "mobile" : "";

    return (
      <div className={`app ${embedCls} ${mobileCls}`}>
        <Router>
          <Switch>
            <Route exact path="/embed" component={HomePage} />
            <Route exact path="/embed/selection" component={SelectionPage} />
            <Route exact path="/embed/:tab" component={MainPage} />
            <Route exact path="/embed/:tab/:sub" component={MainPage} />
            <Route exact path="/embed/:tab/:sub/:cat" component={MainPage} />

            <Route exact path="/" component={HomePage} />
            <Route exact path="/selection" component={SelectionPage} />
            <Route exact path="/:tab" component={MainPage} />
            <Route exact path="/:tab/:sub" component={MainPage} />
            <Route exact path="/:tab/:sub/:cat" component={MainPage} />
          </Switch>
        </Router>
      </div>
    );
  }
}

function mapStateToProps(state: any, ownProps) {
  return {
    appState: state.app
  };
}

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      loadData: ACTIONS.DATA_LOADED
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
